export default "__VITE_ASSET__CHFcsBqW__"